import { createAction, props } from '@ngrx/store';

export const subHeaderActions = {
  triggerAction: createAction(
    '[SubHeader] Trigger action',
    props<{ actionName: string }>()
  ),
};
export type SubHeaderAction = typeof subHeaderActions;
